module.exports = __webpack_public_path__ + "img/file-earmark-slides.038cdb4c.svg";